import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../stores/authStore';
import { colors } from '../styles/colors';

export default function ForceLogoutModal() {
  const { t } = useTranslation();
  const forcedLogout = useAuthStore((s) => s.forcedLogout);
  const clearForcedLogout = useAuthStore((s) => s.clearForcedLogout);

  if (!forcedLogout) return null;

  return (
    <div className="fixed inset-0 z-[99999] flex items-center justify-center"
      style={{ backgroundColor: 'rgba(0,0,0,0.6)' }}>
      <div className="mx-4 w-full max-w-[340px] rounded-xl p-5"
        style={{ backgroundColor: colors.surface, border: `1px solid ${colors.border}` }}>
        <div className="mb-3 text-center text-2xl">&#x1F6AB;</div>
        <h3 className="mb-2 text-center text-sm font-bold" style={{ color: colors.text }}>
          {t('session.forcedLogoutTitle')}
        </h3>
        <p className="mb-4 text-center text-xs leading-relaxed" style={{ color: colors.textMuted }}>
          {t('session.forcedLogoutMessage')}
        </p>
        <button onClick={clearForcedLogout}
          className="w-full rounded-lg py-2.5 text-sm font-bold text-white"
          style={{ backgroundColor: colors.primary }}>
          {t('common.confirm')}
        </button>
      </div>
    </div>
  );
}
